export const DESTROY_TEMP_USER = 'DESTROY_TEMP_USER' as const
export const VERIFY_PHONE_NUMBER = 'VERIFY_PHONE_NUMBER' as const
export const VERIFY_PHONE_NUMBER_SUCCEEDED = 'VERIFY_PHONE_NUMBER_SUCCEEDED' as const
export const RESEND_CODE = 'RESEND_CODE' as const
export const CALL_CODE = 'CALL_CODE' as const
export const VERIFY_CODE = 'VERIFY_CODE' as const
export const VERIFY_CODE_SUCCEEDED = 'VERIFY_CODE_SUCCEEDED' as const
